// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.contractContainer.preContractual.';

const DESCRIPTION = `${DOMAIN}description`,
  LINK = `${DOMAIN}link`,
  TITLE = `${DOMAIN}title`,
  DOWNLOAD_PRECONTRACT_INFORMATION = `${DOMAIN}downloadPrecontractInformation`,
  INFORMATION_TITLE = `${DOMAIN}financialTitle`,
  PDF_TITLE = `${DOMAIN}pdfTitle`,
  TOTAL_BASKET_AMOUNT = `${DOMAIN}totalBasketAmount`,
  INTEREST = `${DOMAIN}interest`,
  TOTAL_AMOUNT = `${DOMAIN}totalAmount`,
  AT_THE_TIME_OF_SHIPPING = `${DOMAIN}atTheTimeOfShipping`,
  EVERY_MONTH = `${DOMAIN}everyMonth`,
  PAYMENT_METHOD = `${DOMAIN}paymentMethod`,
  DOWNLOAD_LINK_PRECONTRACT = `${DOMAIN}documentName`;

const CONSENT = (consent: any): string => `${DOMAIN}${consent.toString()}`;

export {
  DESCRIPTION,
  LINK,
  TITLE,
  DOWNLOAD_PRECONTRACT_INFORMATION,
  PDF_TITLE,
  TOTAL_BASKET_AMOUNT,
  INTEREST,
  TOTAL_AMOUNT,
  AT_THE_TIME_OF_SHIPPING,
  EVERY_MONTH,
  PAYMENT_METHOD,
  INFORMATION_TITLE,
  CONSENT,
  DOWNLOAD_LINK_PRECONTRACT,
};
